import { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import CardAction from '../../../../../components/card/CardAction';
import ConfirmationDialog from '../../../../../components/dialog/ConfirmationDialog';
import './StudentGroupAction.scss';
import { useHandleDeleteStudentGroup } from './StudentGroupActionHooks';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  onStudentGroupDeleted: () => null,
};

export default function DeleteStudentGroupAction(p) {
  const {
    group,
    onStudentGroupDeleted,
  } = { ...defaultProps, ...filterUndefined(p) };
  const [openDialog, setOpenDialog] = useState();

  const {
    deleting,
    deleteNewStudentGroup,
  } = useHandleDeleteStudentGroup({
    onStudentGroupDeleted: () => {
      setOpenDialog(false);
      onStudentGroupDeleted();
    },
  });

  return (
    <>
      <CardAction
        icon={<DeleteIcon fontSize='small' className='delete-icon' aria-hidden='false' />}
        actionHandler={() => { setOpenDialog(true); }}
        className='delete-student-group-action'
        title='Delete Student Group'
        ariaLabel='Delete'
        data-test={`delete-student-group-action-${group.id}`}
        tabIndex={0}
        aria-hidden='false'
      />
      {openDialog ? (
        <ConfirmationDialog
          open={openDialog}
          title='Delete Student Group'
          contentText={`Are you sure you want to delete student group ${group.name}?`}
          confirmLabel='Ok'
          cancelLabel='Cancel'
          onConfirm={() => { deleteNewStudentGroup(group); }}
          onCancel={() => { setOpenDialog(false); }}
          loading={deleting}
          confirmClass='student-group-confirm-action'
          cancelClass='student-group-confirm-action'
        />
      ) : null}
    </>
  );
}
